import { render, staticRenderFns } from "./NotificationCardEventPanel.vue?vue&type=template&id=3c616b6c&scoped=true&"
import script from "./NotificationCardEventPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationCardEventPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardEventPanel.vue?vue&type=style&index=0&id=3c616b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c616b6c",
  null
  
)

export default component.exports